<template>
  <div>
    <div class="password-form">
      <div class="acc-email">{{ emailToRead }}</div>
      <div class="form-group">
        <div class="input-group">
          <input
            type="password"
            v-focus
            name="password"
            v-model="password"
            @keypress.enter="login"
            placeholder="Password..."
            class="form-control input-lg"
          />
          <span class="input-group-btn">
            <button class="btn btn-lg btn-primary btn-block" :disabled="!password" @click="login()">
              <digital-event-preloader type="container" :active="isLoading" />
              <i class="fa fa-fw fa-lg fa-arrow-right"></i>
            </button>
          </span>
        </div>
        <div class="other-email pull-left">
          <router-link :to="{ name: ROUTES.DIGITAL_EVENT_AUTH_LOGIN }">
            <i class="fa fa-fw fa-arrow-left"></i>&nbsp;Use different email address
          </router-link>
        </div>
        <div class="forgot-pass pull-right">
          <a href="javascript:void(0)" @click="sendPasswordConfirmation">
            Forgot password
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthMixin from "./mixins/AuthMixin";
import { mapGetters } from "vuex";

export default {
  name: "SetPassword",
  mixins: [AuthMixin],
  mounted() {},
  data() {
    return {
      password: ""
    };
  },
  computed: {
    ...mapGetters(["isLoading"])
  },
  methods: {
    /**
     * Login using email and password
     */
    async login() {
      if (!this.password) {
        return;
      }

      let { success, messages, errors, user } = await this.$store.dispatch("users/login", {
        email: this.emailToRead,
        password: this.password
      });

      this.showMessages(messages);
      this.showErrors(errors);

      if (success && user) {
        await this.redirectUser(user);
      }
    },

    async sendPasswordConfirmation() {
      let { success, messages, errors } = await this.$store.dispatch("users/sendPasswordConfirmation", {
        email: this.emailToRead
      });

      this.showMessages(messages);
      this.showErrors(errors);

      if (success) {
        this.goTo(this.ROUTES.DIGITAL_EVENT_AUTH_CONFIRM_NEW_PASSWORD);
      }
    }
  }
};
</script>
